var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("New Warehouse")]),_vm._v(" "),_c('location-form',{attrs:{"type":"warehouses"},on:{"success":_vm.emitSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }